// frontend/src/pages/TeacherLogin.js
import React, { useState } from 'react';
import '../livequiz/livequiz.css';
import API_BASE_URL from '../quiz_management/config';

const TeacherLogin = ({ onLoginSuccess }) => {
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [error, setError] = useState(null);
    const [loading, setLoading] = useState(false);

    const handleLogin = async () => {
        if (!email || !password) {
            setError('Please enter email and password');
            return;
        }
        setError(null);
        setLoading(true);
        try {
            const res = await fetch(`${API_BASE_URL}/teachers/auth/login`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ email, password })
            });
            const data = await res.json();
            if (!res.ok) {
                setError(data.detail || 'Login failed');
                setLoading(false);
                return;
            }
            localStorage.setItem('teacherToken', data.token);
            localStorage.setItem('teacherData', JSON.stringify(data.teacher));
            onLoginSuccess(data.token, data.teacher);
        } catch (err) {
            setError('Login failed. Please try again.');
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="livequiz-container">
            <h2 className="livequiz-title">Teacher Login</h2>

            {error && <div className="livequiz-error">{error}</div>}

            <div className="livequiz-setup-card">
                <label className="livequiz-label">Email</label>
                <input
                    type="email"
                    className="livequiz-input"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    placeholder="teacher@example.com"
                />

                <label className="livequiz-label">Password</label>
                <input
                    type="password"
                    className="livequiz-input"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    placeholder="Enter password"
                />

                <button className="livequiz-primary-btn" onClick={handleLogin} disabled={loading}>
                    {loading ? 'Logging in...' : 'Login'}
                </button>
            </div>
        </div>
    );
};

export default TeacherLogin;